import { useEffect, useRef, useState } from "react";

/**
 * Track an element's pixel width via ResizeObserver. Used so SVG charts can set
 * their viewBox width to the real rendered width (1 unit = 1px) instead of
 * relying on preserveAspectRatio, which otherwise stretches strokes and text.
 */
export function useElementWidth<T extends HTMLElement>(fallback = 800) {
  const ref = useRef<T | null>(null);
  const [width, setWidth] = useState(fallback);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect.width;
      if (w && w > 0) setWidth(Math.round(w));
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);
  return { ref, width };
}
